import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { OnSiteMessagingOrchestratorInterface } from '@central-products/interface-on-site-messaging-orchestrator';
import { canShowMessage } from './canShowMessage';
export var OnSiteMessagingOrchestrator = /*#__PURE__*/function (_OnSiteMessagingOrche) {
  _inherits(OnSiteMessagingOrchestrator, _OnSiteMessagingOrche);

  var _super = _createSuper(OnSiteMessagingOrchestrator);

  function OnSiteMessagingOrchestrator() {
    var _this;

    _classCallCheck(this, OnSiteMessagingOrchestrator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "messageCallback", void 0);

    return _this;
  }

  _createClass(OnSiteMessagingOrchestrator, [{
    key: "onMessageRequested",
    value: function onMessageRequested(callback) {
      this.messageCallback = callback; // tslint:disable-next-line:no-empty

      return function () {};
    }
  }, {
    key: "requestMessage",
    value: function requestMessage(message) {
      if (this.messageCallback && canShowMessage()) {
        this.messageCallback(message);
      }
    }
  }]);

  return OnSiteMessagingOrchestrator;
}(OnSiteMessagingOrchestratorInterface);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9PblNpdGVNZXNzYWdpbmdPcmNoZXN0cmF0b3IudHMiXSwibmFtZXMiOlsiT25TaXRlTWVzc2FnaW5nT3JjaGVzdHJhdG9ySW50ZXJmYWNlIiwiY2FuU2hvd01lc3NhZ2UiLCJPblNpdGVNZXNzYWdpbmdPcmNoZXN0cmF0b3IiLCJjYWxsYmFjayIsIm1lc3NhZ2VDYWxsYmFjayIsIm1lc3NhZ2UiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLFNBQ0VBLG9DQURGLFFBSU8sNERBSlA7QUFLQSxTQUFTQyxjQUFULFFBQStCLGtCQUEvQjtBQUVBLFdBQWFDLDJCQUFiO0FBQUE7O0FBQUE7O0FBQUE7QUFBQTs7QUFBQTs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7O0FBQUE7O0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUEsdUNBRzRCQyxRQUg1QixFQUc0RDtBQUN4RCxXQUFLQyxlQUFMLEdBQXVCRCxRQUF2QixDQUR3RCxDQUd4RDs7QUFDQSxhQUFPLFlBQU0sQ0FBRSxDQUFmO0FBQ0Q7QUFSSDtBQUFBO0FBQUEsbUNBVXdCRSxPQVZ4QixFQVVnRDtBQUM1QyxVQUFJLEtBQUtELGVBQUwsSUFBd0JILGNBQWMsRUFBMUMsRUFBOEM7QUFDNUMsYUFBS0csZUFBTCxDQUFxQkMsT0FBckI7QUFDRDtBQUNGO0FBZEg7O0FBQUE7QUFBQSxFQUFpREwsb0NBQWpEIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtcbiAgT25TaXRlTWVzc2FnaW5nT3JjaGVzdHJhdG9ySW50ZXJmYWNlLFxuICBNZXNzYWdlLFxuICBDYWxsYmFjayxcbn0gZnJvbSAnQGNlbnRyYWwtcHJvZHVjdHMvaW50ZXJmYWNlLW9uLXNpdGUtbWVzc2FnaW5nLW9yY2hlc3RyYXRvcic7XG5pbXBvcnQgeyBjYW5TaG93TWVzc2FnZSB9IGZyb20gJy4vY2FuU2hvd01lc3NhZ2UnO1xuXG5leHBvcnQgY2xhc3MgT25TaXRlTWVzc2FnaW5nT3JjaGVzdHJhdG9yIGV4dGVuZHMgT25TaXRlTWVzc2FnaW5nT3JjaGVzdHJhdG9ySW50ZXJmYWNlIHtcbiAgcHJpdmF0ZSBtZXNzYWdlQ2FsbGJhY2s/OiBDYWxsYmFjaztcblxuICBwdWJsaWMgb25NZXNzYWdlUmVxdWVzdGVkKGNhbGxiYWNrOiBDYWxsYmFjayk6ICgpID0+IHZvaWQge1xuICAgIHRoaXMubWVzc2FnZUNhbGxiYWNrID0gY2FsbGJhY2s7XG5cbiAgICAvLyB0c2xpbnQ6ZGlzYWJsZS1uZXh0LWxpbmU6bm8tZW1wdHlcbiAgICByZXR1cm4gKCkgPT4ge307XG4gIH1cblxuICBwdWJsaWMgcmVxdWVzdE1lc3NhZ2UobWVzc2FnZTogTWVzc2FnZSk6IHZvaWQge1xuICAgIGlmICh0aGlzLm1lc3NhZ2VDYWxsYmFjayAmJiBjYW5TaG93TWVzc2FnZSgpKSB7XG4gICAgICB0aGlzLm1lc3NhZ2VDYWxsYmFjayhtZXNzYWdlKTtcbiAgICB9XG4gIH1cbn1cbiJdfQ==